var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemNoHighlight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.478 3.22a1.725 1.725 0 0 1 2.317.118l1.459 1.47.119.131a1.75 1.75 0 0 1 0 2.198l-.12.133-8.872 8.926-.505-.508-1.143 1.14-3.972-1.946 2.17-2.157-.458-.46 8.874-8.927zm-6.556 9.044 1.459 1.468 1.735-1.745-1.46-1.468zm2.959-2.976 1.459 1.467 4.69-4.716-1.46-1.468z",
  clipRule: "evenodd"
})));
export default SvgGemNoHighlight;